export default {
      id: "battery-lvl-100-usage",
      viewBox: "0 0 22 14",
      url: __webpack_public_path__ + "img/icons.svg#battery-lvl-100",
      toString: function () {
        return this.url;
      }
    }